import { createReducer } from '@reduxjs/toolkit';
import {
  setManufacturers,
  setMaxPrice,
  setMinPrice,
  setSearchText,
  setPartsSearchText,
} from '../Actions/SearchActions';
import { SelectOption } from '../Models/SelectOption';

type SearchRequestReference = {
  searchTextState: string | null;
  searchPartsTextState: string | null;
  manufacturersState: SelectOption[] | null;
  minPriceState: number | null;
  maxPriceState: number | null;
};

const initialState: SearchRequestReference = {
  searchTextState: '',
  searchPartsTextState: '',
  manufacturersState: null,
  minPriceState: null,
  maxPriceState: null,
};

const SearchReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(setSearchText, (state, action) => {
      return { ...state, searchTextState: action.payload };
    })
    .addCase(setPartsSearchText, (state, action) => {
      return { ...state, searchPartsTextState: action.payload };
    })
    .addCase(setManufacturers, (state, action) => {
      return { ...state, manufacturersState: action.payload };
    })
    .addCase(setMinPrice, (state, action) => {
      return { ...state, minPriceState: action.payload };
    })
    .addCase(setMaxPrice, (state, action) => {
      return { ...state, maxPriceState: action.payload };
    });
});

export default SearchReducer;
